import { supabase } from '@/lib/supabase';

interface UgcEventResponse {
  success: boolean;
  message: string;
  email: string;
}

const DEFAULT_KLAVIYO_API_KEY = 'pk_45b5effa8c79ecda4a9e308103d89e09f3';

/**
 * Sends a UGC event notification to the backend and triggers an email to the brand
 * @param brandId The ID of the brand that received the UGC
 * @returns Promise<UgcEventResponse>
 */
export const triggerUgcEmail = async (brandId: string): Promise<UgcEventResponse> => {
  try {
    // Get the brand's email and Klaviyo API key from Supabase
    const { data: brandData, error: brandError } = await supabase
      .from('brands')
      .select('email, klaviyo_api_key')
      .eq('id', brandId)
      .single();

    if (brandError || !brandData) {
      console.error('Error fetching brand data:', brandError);
      return { success: false, message: 'Brand not found', email: '' };
    }

    // Send the UGC event to the backend
    const response = await fetch('https://photoharvestjsbackend.vercel.app/api/ugc-event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'klaviyo-api-key': brandData.klaviyo_api_key || DEFAULT_KLAVIYO_API_KEY,
        'email': brandData.email
      }
    });

    const data: UgcEventResponse = await response.json();
    console.log('UGC Event Response:', data);
    return data;
  } catch (error) {
    console.error('Error triggering UGC email:', error);
    return { success: false, message: 'Failed to send email', email: '' };
  }
}; 